import React from 'react';


function Header() {
  return (
    <header className="app-header">
      <h1>Mars Mission Application Form</h1>
    </header>
  );
}

export default Header;
